export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/tim-profile-8f708d671ee0872d2756da5ed0381ebf.png";